import type { ClientInquiry, ClientInquiryInput } from '@maru44/huntre-utils/src/models/clientInquiry'
import { addDoc, collection, serverTimestamp } from 'firebase/firestore'
import { useCallback } from 'react'
import { firestore } from 'src/utils/firebase'
import { type UsePaginatedCollectionOptions, usePaginatedCollection } from '../usePaginatedCollection'

export const useClientInquiries = (clientId: string, options: UsePaginatedCollectionOptions = {}) => {
  const collectionPath = `clients/${clientId}/clientInquiries`

  const listClientInquiries = usePaginatedCollection<ClientInquiry>(collectionPath, {
    ...options,
    disabled: !clientId || options.disabled,
  })

  const createInquiry = useCallback(
    async (input: ClientInquiryInput) => {
      const ref = collection(firestore, collectionPath)
      const now = serverTimestamp()
      await addDoc(ref, {
        ...input,
        resolvedAt: null,
        createdAt: now,
        updatedAt: now,
      })
    },
    [collectionPath],
  )

  return {
    listClientInquiries,
    createInquiry,
  }
}
